import styled from 'styled-components';

import ModalBase from '@components/common/core/DataDisplay/Modal';

export const Modal = styled(ModalBase)`
  max-width: 564px;
  box-sizing: border-box;
  width: 100%;
`;
